import {
  CANCEL_EDITION,
  CLEAN_ERROR,
  CREATE_UTILITY_DEPLOYMENT_TEMPLATE,
  CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING,
  DELETE_UTILITY_DEPLOYMENT_TEMPLATE,
  DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING,
  FETCH_UTILITY_DEPLOYMENT_TEMPLATE,
  FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID,
  FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_ERROR,
  FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_PENDING,
  FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING,
  SORT,
  UPDATE_UTILITY_DEPLOYMENT_TEMPLATE,
  UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR,
  UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING,
} from 'services/GameHosting/DeploymentTemp/UtilityTemplate/types';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  utilityDepTemp: [],
  sortBy: 'name',
  sortDirection: 'ASC',
  params: {},
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
};

const CUD_PROPERTIES = {
  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,
  createIsCompleted: false,
  createIsPending: false,
  createIsError: null,
  updateIsCompleted: false,
  updateIsPending: false,
  updateIsError: null,
  deleteIsCompleted: false,
  deleteIsPending: false,
  deleteIsError: null,
};

const utilityTemplateReducer = (
  state = {
    ...INITIAL_STATE,
    ...CUD_PROPERTIES,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_UTILITY_DEPLOYMENT_TEMPLATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        utilityDepTemp: sort(action.data, {
          sortBy: state.sortBy,
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortDirection: state.sortDirection,
          sortSearchValue: (state.params as $TSFixMe).sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchIsError: action.error,
      };
    case FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    case FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchByIdIsCompleted: false,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchByIdIsError: action.error,
      };

    case CREATE_UTILITY_DEPLOYMENT_TEMPLATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        utilityDepTemp: addNew(action.data, state.utilityDepTemp),
        createIsCompleted: true,
        createIsPending: false,
        createIsError: null,
      };
    case CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: true,
        createIsError: null,
      };
    case CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        createIsCompleted: true,
        createIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createIsError: action.error,
      };

    case UPDATE_UTILITY_DEPLOYMENT_TEMPLATE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const indexToUpdate = state.utilityDepTemp.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        utilityDepTemp: state.utilityDepTemp.map((item, index) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...item,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.data,
          };
        }),
        updateIsCompleted: true,
        updateIsPending: false,
        updateIsError: null,
      };
    }

    case UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        updateIsCompleted: false,
        updateIsPending: true,
        updateIsError: null,
      };
    case UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        updateIsCompleted: true,
        updateIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateIsError: action.error,
      };

    case DELETE_UTILITY_DEPLOYMENT_TEMPLATE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const index = state.utilityDepTemp.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        utilityDepTemp: [...state.utilityDepTemp.slice(0, index), ...state.utilityDepTemp.slice(index + 1)],
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    }

    case DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING:
      return {
        ...state,
        deleteIsCompleted: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR:
      return {
        ...state,
        deleteIsCompleted: true,
        deleteIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteIsError: action.error,
      };

    case CANCEL_EDITION:
      return {
        ...state,
        utilityDepTemp: state.utilityDepTemp.filter((item) => (item as $TSFixMe).id),
      };
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        utilityDepTemp: sort(state.utilityDepTemp, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case CLEAN_ERROR:
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (state[action.reducerProperty] && state[action.reducerProperty][action.errorIndex]) {
        return {
          ...state,

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          [action.reducerProperty]:
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            action.mode === 'property'
              ? null
              : // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                [...state[action.reducerProperty].slice(0, action.errorIndex), ...state[action.reducerProperty].slice(action.errorIndex + 1)],
        };
      }

      return {
        ...state,
      };
    case 'RESET_UTILITY_DEPLOYMENT_TEMPLATE_REDUCER':
    case 'RESET_REDUCER':
      return {
        ...INITIAL_STATE,
        ...CUD_PROPERTIES,
      };
    default:
      return state;
  }
};

export default utilityTemplateReducer;
